<template>
  <div class="warp">
    <!-- <iframe v-if="flage" class="inter" src="https://youji-ctp-ios.oss-cn-hangzhou.aliyuncs.com/AppHelp/index.html" frameborder="0"></iframe> -->
    <iframe v-if="flage" class="inter" src="" frameborder="0"></iframe>
    <!-- <iframe v-if="flage" class="inter" :src="helpAddress" frameborder="0"></iframe> -->
    <div class="headerWrapper">
      <span class="install" @click="goBack">
        <i class="icon iconfont">&#xe604;</i>
        返回
      </span>
      设置
    </div>
    <ul class="setConent">
      <li>
        <span>当前版本号</span>
        <span style="color:#ccc">{{versions}}</span>
      </li>
      <!--
      <li @click="lookHelp">
        <span>帮助说明书</span>
      </li>
      -->
      <li @click="changeword">
        <span>修改密码</span>
      </li>
      <li style="margin-top:0.3rem">
        <span>下单,撤单,反手确认</span>
        <span><onoff/></span>
      </li>
    </ul>
  </div>
</template>

<script>
import yjheader from "@/components/common/yjheader";
import art from "../../../static/js/proto/art/Art.js";
import model from "../../../static/js/proto/Model.js";
import front from "../../../static/js/proto/CtpFront.js";
import * as SubUtils from "@/store/SubUtils";
import onoff from "../../views/Condition/components/OnOff/OnOff";
import * as version from '@/version.js';
export default {
  name: "setPage",
  components: {
    yjheader,
    onoff,
  },
  data() {
    return {
      versions: '',
      flage: false,
      helpAddress: '',
    }
  },

  methods: {
    goBack() {
      this.$router.push({ path: "/home/trade" });
    },
    lookHelp() {
      this.flage = true;
    },
    changeword() {
      this.$router.push('/ChangeWord')
    }
  },
  mounted() {
    this.versions = version.version;
    window.addEventListener('message', (e) => {
      // console.log(e.data);
      this.flage = e.data;
    })
  },
  activated() {
      this.helpAddress = helpAddress;
  },
};
</script>

<style scoped>
.warp {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}
.iconfont {
  color: #fff;
  font-size: 0.36rem;
}
.headerWrapper {
  background: #1c201f;
  color: #fff;
  font-size: 0.36rem;
  vertical-align: center;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  position: relative;
}
.headerWrapper .install {
  position: absolute;
  top: 0;
  left: 0.1rem;
  color: #fff;
  font-size: 0.32rem;
}
.setConent {
  margin-top: 0.1rem;
  overflow: scroll;
  width: 100%;
  position: absolute;
  top: 1.1rem;
  bottom: 0;
}
.setConent li{
  font-size: 0.32rem;
  height: 1rem;
  line-height: 1rem;
  width: 94%;
  padding: 0 3%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  background: #1c201f;
  border-bottom: 1px solid #161712;
}
.setConent li span {
    white-space:nowrap;
}
.inter {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 999;
  background: #fff;
  height: 100%;
  font-size: 0.2rem;
  background: #161712;
  /* margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top); */
}
</style>




// WEBPACK FOOTER //
// src/components/yj/setPage.vue